import React from "react";

import "./Header.css";

import { Link } from "react-scroll";

const Header = () => {
  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="destination-sbhm" smooth={true} duration={1500}>
          <img src="/logo.svg" alt="Logo" className="navbar-logo" />
        </Link>

        <ul className="navbar-links">
          <li>
            <Link to="destination-about" smooth={true} duration={1500}>
              <a href="#about">Qui sommes nous</a>
            </Link>
          </li>
          <li>
            <Link to="destination-piscines" smooth={true} duration={1500}>
              <a href="#piscines">Piscines</a>
            </Link>
          </li>
          <li>
            <Link to="destination-avis" smooth={true} duration={1500}>
              <a href="#avis">Avis</a>
            </Link>
          </li>
        </ul>
      </div>

      <Link to="destination-contact" smooth={true} duration={1500}>
        <button
          className="navbar-button"
          href="#devis"
          aria-label="bouton pour valider la demande de devis"
        >
          Demandez un devis
        </button>
      </Link>
    </nav>
  );
};

export default Header;
